import { render } from "./release.vue?vue&type=template&id=2c060f1e&scoped=true"
import script from "./release.vue?vue&type=script&lang=js"
export * from "./release.vue?vue&type=script&lang=js"

import "./release.vue?vue&type=style&index=0&id=2c060f1e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2c060f1e"

export default script